export const getClanUsersInfo = async (clanId, token) => {
    try {
        const response = await fetch(`https://blue-moon-app-backend.vercel.app/clan/${clanId}/users`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`,
            },
        });
        if (response.ok) {
            const data = await response.json();
            const clanUsersData = data.users;
            return clanUsersData;
        } else {
            throw new Error('Failed to fetch user data');
        }
    } catch (error) {
        console.error('Error:', error);
    }
}